module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.showHeader) ? _c('titleBar', {
    attrs: {
      "leftEle": _vm.leftEle,
      "rightEle": _vm.rightEle,
      "rightText": _vm.rightText
    }
  }) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-59954a04","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/titleBar/backTitleBar.vue
// module id = sBQ1
// module chunks = 51